"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoraDeploymentCommand = void 0;
const clipanion_1 = require("clipanion");
const t = __importStar(require("typanion"));
const plugin_1 = require("@datadog/datadog-ci-base/helpers/plugin");
const __1 = require("../..");
class DoraDeploymentCommand extends __1.BaseCommand {
    constructor() {
        super(...arguments);
        this.serviceParam = clipanion_1.Option.String('--service', { env: 'DD_SERVICE' });
        this.env = clipanion_1.Option.String('--env', { env: 'DD_ENV' });
        this.startedAt = clipanion_1.Option.String('--started-at', {
            required: true,
            validator: t.isDate(),
            description: 'In Unix seconds or ISO8601 (Examples: 1699960648, 2023-11-14T11:17:28Z)',
        });
        this.finishedAt = clipanion_1.Option.String('--finished-at', {
            validator: t.isDate(),
            description: 'In Unix seconds or ISO8601 (Examples: 1699961048, 2023-11-14T11:24:08Z)',
        });
        this.version = clipanion_1.Option.String('--version', {
            description: 'The version of the service being deployed',
        });
        this.gitRepoURL = clipanion_1.Option.String('--git-repository-url', {
            description: 'Example: https://github.com/DataDog/datadog-ci.git',
        });
        this.gitCommitSHA = clipanion_1.Option.String('--git-commit-sha', {
            description: 'Example: 102836a25f5477e571c73d489b3f0f183687068e',
        });
        this.skipGit = clipanion_1.Option.Boolean('--skip-git', false, {
            description: 'Disables sending git URL and SHA. Change Lead Time will not be available',
        });
        this.team = clipanion_1.Option.String('--team', {
            description: 'The team responsible for the deployment',
        });
        this.customTags = clipanion_1.Option.Array('--custom-tags', {
            description: 'Custom tags to add to the deployment event in the format key:value, max 100 tags per deployment event',
        });
        this.fips = clipanion_1.Option.Boolean('--fips', false);
        this.fipsIgnoreError = clipanion_1.Option.Boolean('--fips-ignore-error', false);
        this.verbose = clipanion_1.Option.Boolean('--verbose', false, { hidden: true });
        this.dryRun = clipanion_1.Option.Boolean('--dry-run', false);
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, plugin_1.executePluginCommand)(this);
        });
    }
}
exports.DoraDeploymentCommand = DoraDeploymentCommand;
DoraDeploymentCommand.paths = [['dora', 'deployment']];
DoraDeploymentCommand.usage = clipanion_1.Command.Usage({
    category: 'CI Visibility',
    description: 'Send a new Deployment event for DORA Metrics to Datadog.',
    details: `
    This command sends details to Datadog about a deployment of a service.\n
    See README for more details.
    `,
    examples: [
        [
            'Send a DORA deployment event for a service to the prod environment',
            'datadog-ci dora deployment --service my-service --env prod \\\n' +
                '    --started-at 1699960648 --finished-at 1699961048 \\\n' +
                '    --git-repository-url https://github.com/my-organization/my-repository \\\n' +
                '    --git-commit-sha 102836a25f5477e571c73d489b3f0f183687068e \\\n' +
                '    --version 1.0.0',
        ],
        [
            'Send a DORA deployment event with automatically extracted Git info (for deployments triggered from CI in the same repository as the application). The deployment is assumed to target the current HEAD commit',
            'datadog-ci dora deployment --service my-service --started-at $deploy_start --finished-at `date +%s`',
        ],
        [
            'Send a DORA deployment event to the datadoghq.eu site',
            'DD_SITE=datadoghq.eu datadog-ci dora deployment --service my-service --started-at $deploy_start',
        ],
        [
            'Send a DORA deployment event without git info. Change Lead Time is not available without Git info. The deployment finished-at is set to the current time',
            'datadog-ci dora deployment --service my-service --started-at $deploy_start --skip-git',
        ],
        [
            'Send a DORA deployment event providing the service name and env through environment vars',
            'DD_SERVICE=my-service DD_ENV=prod datadog-ci dora deployment --started-at $deploy_start',
        ],
    ],
});
//# sourceMappingURL=deployment.js.map